import { Identifiable, List, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedTask, Linker } from "../linkers/types";
import { formatDate } from "../utils/formatDate";
import { mapError } from "../utils/mapError";

function saveTask(httpClient: HttpClient, linker: Linker) {
  return (list: Identifiable<List>, { startDate, endDate, ...task }: Task) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/tasks`,
        method: HttpMethods.POST,
        data: {
          name: task.name,
          description: task.description,
          ...(task.activityKeyRank !== -1 && {
            activityKeyRank: task.activityKeyRank,
          }),
          ...(startDate && { startDate: formatDate(startDate) }),
          ...(endDate && { endDate: formatDate(endDate) }),
          activity: `/activities/${list.uuid}`,
          status: `/statuses/${task.status.uuid}`,
          ...(!!task.attributes && { attributes: task.attributes }),
        },
      })
      .then(linker.linkTask)
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            invalidDateRange: "invalidDateRange",
            startDateOutOfBound: "startDateOutOfBound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { saveTask };
